import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { getAuth, updateProfile } from "firebase/auth";
import firebase from 'firebase/compat/app';
import { Router } from '@angular/router';
import { LoadingService } from '../../services/loading.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.page.html',
  styleUrls: ['./registration.page.scss'],
})
export class RegistrationPage implements OnInit {
  // name : any;
  mobile: any = this.userService.mobile;
  // dob : any;
  // referral : any;
  // email : any;
  // city : any;
  msg: any;
  constructor(
    private userService: UserService,
    private loadingService: LoadingService,
    private router: Router,
    private auth: AuthenticationService) { }

  ngOnInit() {
    this.mobile = this.userService.mobile;
    console.log(this.mobile)
  }

  register = new FormGroup({
    name: new FormControl("", Validators.required),
    // mobile : new FormControl("",Validators.required),
    dob: new FormControl("", Validators.required),
    referral: new FormControl(""),
    email: new FormControl("", [Validators.required, Validators.email]),
    city: new FormControl("", Validators.required)
  })

  continue() {
    let data = {
      name: this.register.value.name,
      mobile: this.mobile,
      dob: this.register.value.dob,
      referral: this.register.value.referral,
      email: this.register.value.email,
      uid: this.userService.uid,
      city: this.register.value.city
    }
    console.log(data);
    this.userService.setContext('new user registration', data);
    let name = '[LOG] New User Registration';
    var error = new Error();
    error.name = name;
    this.userService.sendException(error)
    this.loadingService.presentLoading("");
    this.userService.registration(data).subscribe((res) => {
      this.msg = res;
      const auth = getAuth();

      console.log("new user registration this.msg ", this.msg);
      console.log("new user registration firebase.auth().currentUser.uid ", firebase.auth().currentUser.uid);
      this.userService.initialize(firebase.auth().currentUser.uid);

    console.log(data);
      updateProfile(auth.currentUser, {
        displayName: this.register.value.name
      }).then(() => {

      }).catch((error) => {

      });
      if (this.msg) {
        this.loadingService.dismiss();
        this.router.navigate(['/'])
      }
      console.log(res)
    })
  }

}
